import {RemotePostPreviewsAnalysis} from 'data/usecases/private/refund/request-preview';
import {PostPreviewsAnalysis} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostPreviewsAnalysis = (): PostPreviewsAnalysis =>
	new RemotePostPreviewsAnalysis(
		makeBFFApiUrl(RefundFlowEndPoints.previewsAnalysis),
		makeAuthorizeHttpClientDecorator(),
	);
